import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={14}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33 2.037a.466.466 0 0 0-.66 0l-1.4 1.4a.466.466 0 1 0 .66.66L7 3.027l1.07 1.07a.465.465 0 1 0 .66-.66l-1.4-1.4ZM8.07 10.903 7 11.973l-1.07-1.07a.466.466 0 1 0-.66.66l1.4 1.4a.465.465 0 0 0 .66 0l1.4-1.4a.467.467 0 1 0-.66-.66ZM12.463 7.17l-1.4-1.4a.467.467 0 1 0-.66.66l1.07 1.07-1.07 1.07a.466.466 0 1 0 .66.66l1.4-1.4a.466.466 0 0 0 0-.66ZM3.597 5.77a.466.466 0 0 0-.66 0l-1.4 1.4a.466.466 0 0 0 0 .66l1.4 1.4a.466.466 0 1 0 .66-.66L2.527 7.5l1.07-1.07a.466.466 0 0 0 0-.66Z"
      fill="#636F7C"
    />
    <path
      d="M7 .5c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7Zm0 13.067A6.074 6.074 0 0 1 .933 7.5 6.074 6.074 0 0 1 7 1.433 6.074 6.074 0 0 1 13.067 7.5 6.074 6.074 0 0 1 7 13.567Z"
      fill="#636F7C"
    />
  </svg>
);

export default SvgComponent;
